/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostwizercompanyenablePostWizerCompanyEnableResult
 */
export interface JumboPostwizercompanyenablePostWizerCompanyEnableResult {
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyenablePostWizerCompanyEnableResult
     */
    message?: string;
}

/**
 * Check if a given object implements the JumboPostwizercompanyenablePostWizerCompanyEnableResult interface.
 */
export function instanceOfJumboPostwizercompanyenablePostWizerCompanyEnableResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostwizercompanyenablePostWizerCompanyEnableResultFromJSON(json: any): JumboPostwizercompanyenablePostWizerCompanyEnableResult {
    return JumboPostwizercompanyenablePostWizerCompanyEnableResultFromJSONTyped(json, false);
}

export function JumboPostwizercompanyenablePostWizerCompanyEnableResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostwizercompanyenablePostWizerCompanyEnableResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JumboPostwizercompanyenablePostWizerCompanyEnableResultToJSON(value?: JumboPostwizercompanyenablePostWizerCompanyEnableResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

